import gql from 'graphql-tag'

export default gql`
    query lendingAnalysis($startDate: String, $endDate: String) {
        lendingAnalysis(startDate: $startDate, endDate: $endDate) {
            Date
            UserCount {
                Total
                GroupSplit {
                    Name
                    Count
                }
                UserGroupSplit {
                    Name
                    Count
                }
            }
            LendingEngagementCount {
                Total
                UserGroupSplit {
                    Name
                    Count
                }
                GroupSplit {
                    Name
                    Count
                }
            }
        }
    }
`
